jQuery(function () {
  var Accordion = function (el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    // Variables
    var links = this.el.find(".question-wrapper-content");
    // Event
    links.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
  };
  Accordion.prototype.dropdown = function (e) {
    console.log("clicked");
    var $el = e.data.el;
    ($this = jQuery(this)), ($secondChild = $this.children().eq(1));
    $firstChildTitle = $this
      .children()
      .eq(0)
      .find(".question-title")
      .hasClass("active");
    if (!$this.hasClass("open")) {
      $secondChild.slideDown();
      $secondChild.css("display", "flex");
    } else {
      $secondChild.slideUp();
      $this.children().eq(0).find(".question-title").toggleClass("active");
    }
    $this.toggleClass("open");
    if (!e.data.multiple) {
      $el
        .find(".question-wrapper-content__answer")
        .not($secondChild)
        .slideUp()
        .parent()
        .removeClass("open");
      $el
        .find(".question-wrapper-content__question .question-title")
        .removeClass("active");
    }
    if (!$firstChildTitle) {
      $this.children().eq(0).find(".question-title").addClass("active");
    } else {
      $this.children().eq(0).find(".question-title").removeClass("active");
    }
  };
  var accordion = new Accordion($("#question-wrapper"), false);
});
